import { render, staticRenderFns } from "./CreateProgramAward.vue?vue&type=template&id=37dcf17c&scoped=true&"
import script from "./CreateProgramAward.vue?vue&type=script&setup=true&lang=js&"
export * from "./CreateProgramAward.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./CreateProgramAward.vue?vue&type=style&index=0&id=37dcf17c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37dcf17c",
  null
  
)

export default component.exports